import { TimeSeriesChartItem } from "../../TimeSeriesStackedChart/TimeSeriesStackedChart";
import { Legend } from "../Legend";
import moment, { MomentInput } from "moment";
import { OptionalNumberFormatter } from "../../../types/OptionalNumberFormatter";

export const TimeSeriesLineChartLegend = ({
  timeSeriesItems,
  valueFormatter,
  showTotal = true,
}: {
  timeSeriesItems: TimeSeriesChartItem[];
  valueFormatter?: OptionalNumberFormatter;
  showTotal?: boolean;
}) => {
  return (
    <Legend
      legendItems={getTimeSeriesLegendItems(
        timeSeriesItems,
        valueFormatter,
        showTotal
      )}
    />
  );
};

const getTimeSeriesLegendItems = (
  timeSeriesItems: TimeSeriesChartItem[],
  valueFormatter: OptionalNumberFormatter = (v) => `${v}`,
  showTotal?: boolean
) => {
  return timeSeriesItems.map((item) => {
    const value = item.entries.reduce((acc, curr) => {
      const currentDateIsLater = moment(curr.date).isAfter(acc.date);
      if (currentDateIsLater) {
        return curr;
      }
      return acc;
    }, INITIAL_VALUE).value;

    return {
      label: item.category,
      value: showTotal ? valueFormatter(value) : undefined,
      color: item.color,
    };
  });
};

const INITIAL_VALUE: { date?: MomentInput; value?: number } = {
  date: new Date(1970, 1, 1),
};
